export const getFileUrl = (fileId: string) => {
  return `https://api.arenpro.com/file/${fileId}`
}
